<template> 
   <div>
       {{manage}}
   </div>
</template> 
<script>
   
    export default {
        name:'manage1',
        data () {
            return {
             
            }
        },
        props:['manage'],
        computed: {
       
        },
        methods: {
      
        },
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style scoped>
    
</style>